/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Protects_BodyInputs */

const en_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why this protects your body`)
};

const es_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué esto protege tu cuerpo`)
};

const de_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum das Ihren Körper schützt`)
};

const zh_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么这可以保护你的身体`)
};

const ar_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا يحمي هذا جسمك`)
};

const fr_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi cela protège votre corps`)
};

const vi_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao điều này bảo vệ cơ thể bạn`)
};

const sw_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini hii inalinda mwili wako`)
};

const th_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหตุใดจึงช่วยปกป้องร่างกายของคุณ`)
};

const bs_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto ovo štiti vaše tijelo`)
};

const ja_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この方法が体を守る理由`)
};

const ko_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 방법이 몸을 보호하는 이유`)
};

const pt_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que isso protege seu corpo`)
};

const it_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché questo protegge il tuo corpo`)
};

const sv_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför detta skyddar din kropp`)
};

const nl_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom dit je lichaam beschermt`)
};

const da_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor dette beskytter din krop`)
};

const nb_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor dette beskytter kroppen din`)
};

const fi_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi tämä suojelee kehoasi`)
};

const pl_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego to chroni Twoje ciało`)
};

const ru_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему это защищает ваше тело`)
};

const tr_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu neden vücudunuzu korur`)
};

const hi_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह आपके शरीर की रक्षा क्यों करता है`)
};

const id_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa ini melindungi tubuh Anda`)
};

const ms_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa ini melindungi badan anda`)
};

const cs_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč to chrání vaše tělo`)
};

const el_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί αυτό προστατεύει το σώμα σας`)
};

const he_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה זה מגן על הגוף שלכם`)
};

const af_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom dit jou liggaam beskerm`)
};

const hu_method_protects_body = /** @type {(inputs: Method_Protects_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért védi ez a testedet`)
};

/**
* | output |
* | --- |
* | "Why this protects your body" |
*
* @param {Method_Protects_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_protects_body = /** @type {((inputs?: Method_Protects_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Protects_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_protects_body(inputs)
	if (locale === "de") return de_method_protects_body(inputs)
	if (locale === "zh") return zh_method_protects_body(inputs)
	if (locale === "ar") return ar_method_protects_body(inputs)
	if (locale === "fr") return fr_method_protects_body(inputs)
	if (locale === "vi") return vi_method_protects_body(inputs)
	if (locale === "sw") return sw_method_protects_body(inputs)
	if (locale === "th") return th_method_protects_body(inputs)
	if (locale === "bs") return bs_method_protects_body(inputs)
	if (locale === "ja") return ja_method_protects_body(inputs)
	if (locale === "ko") return ko_method_protects_body(inputs)
	if (locale === "pt") return pt_method_protects_body(inputs)
	if (locale === "it") return it_method_protects_body(inputs)
	if (locale === "sv") return sv_method_protects_body(inputs)
	if (locale === "nl") return nl_method_protects_body(inputs)
	if (locale === "da") return da_method_protects_body(inputs)
	if (locale === "nb") return nb_method_protects_body(inputs)
	if (locale === "fi") return fi_method_protects_body(inputs)
	if (locale === "pl") return pl_method_protects_body(inputs)
	if (locale === "ru") return ru_method_protects_body(inputs)
	if (locale === "tr") return tr_method_protects_body(inputs)
	if (locale === "hi") return hi_method_protects_body(inputs)
	if (locale === "id") return id_method_protects_body(inputs)
	if (locale === "ms") return ms_method_protects_body(inputs)
	if (locale === "cs") return cs_method_protects_body(inputs)
	if (locale === "el") return el_method_protects_body(inputs)
	if (locale === "he") return he_method_protects_body(inputs)
	if (locale === "af") return af_method_protects_body(inputs)
	if (locale === "hu") return hu_method_protects_body(inputs)
	return en_method_protects_body(inputs)
});